import { useForm, FormProvider, SubmitHandler } from "react-hook-form";
import { Container, Row, Col, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Footer from "../footer/Footer";
import ESInput from "../../controls/ESInput";
import loginbg from "../../assets/images/login.png";
import "../login/signup.scss";
import Loader from "../loader/Loader";
import { useState } from "react";
import { ToastTypeCode, showToast } from "../../utils/Constant";
import { organizationInsertForSignUp } from "../../utils/ApiUrl";
import { axiosPost } from "../../utils/AxiosHelper";
import esurveylogonew from "../../assets/images/logo.png";
import { useParams } from 'react-router-dom';

interface SignupUser {
  organizationName: string;
  firstName: string;
  lastName: string;
  password: string;
  email: string;
  contactNumber: number | null;
  countryCode: number | null;
  token?: string;
  tenentId?: string;
  isActive?: boolean;
  planId?:number;
}

interface TenantLicenseData {
  contact_email: string;
  contact_person: string;
  product_code: string;
  tenant_name: string;
  tenant_code?: string;
  plan_id: number;
}

const Signup = () => {
  const methods = useForm<SignupUser>({
    defaultValues: {
      organizationName: "",
      firstName: "",
      lastName: "",
      password: "",
      email: "",
      contactNumber: null,
      countryCode: null,
      isActive: true,
    },
  });
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { planId } = useParams();
  
  const onSubmit: SubmitHandler<SignupUser> = async (data) => {
    const transformedData = {
      ...data,
      isActive: data.isActive ? 1 : 0,
      planId:planId || null,
    };
    setLoading(true);
    try {
      const response: any = await axiosPost(
        organizationInsertForSignUp,
        transformedData
      );

      if (response?.data?.Status === 200) {
        showToast("Signup successful", ToastTypeCode?.SUCCESS);
        navigate("/login");
      } else if (response?.data?.ErrorMessage != null) {
        showToast(response?.data?.ErrorMessage, ToastTypeCode?.ERROR);
      }
    } catch (error) {
      showToast("Signup unsuccessful", ToastTypeCode?.ERROR);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Container fluid className="form">
        <div className="main-content">
          <Row>
            <Col lg="6" className="d-block m-auto login-bg">
              <div className="login-card">
                <img src={esurveylogonew} className="esurveylogo" alt="logo" />
                <h2>Sign Up</h2>
                {loading ? (
                  <Loader />
                ) : (
                  <FormProvider {...methods}>
                    <form onSubmit={methods.handleSubmit(onSubmit)}>
                      <div className="form-sec">
                        <Form.Group as={Col} className="mb-1">
                          <Form.Label>
                            Organization Name{" "}
                            <span className="text-danger">*</span>
                          </Form.Label>
                          <ESInput
                            className={"form-control"}
                            name={"organizationName"}
                            placeholder={"Organization Name"}
                            type={"text"}
                            required={true}
                          />
                        </Form.Group>

                        <Row>
                          <Form.Group as={Col} md={6} className="mb-1">
                            <Form.Label>
                              First Name <span className="text-danger">*</span>
                            </Form.Label>
                            <ESInput
                              className={"form-control"}
                              name={"firstName"}
                              placeholder={"First Name"}
                              type={"text"}
                              required={true}
                            />
                          </Form.Group>

                          <Form.Group as={Col} md={6} className="mb-1">
                            <Form.Label>
                              Last Name <span className="text-danger">*</span>
                            </Form.Label>
                            <ESInput
                              className={"form-control"}
                              name={"lastName"}
                              placeholder={"Last Name"}
                              type={"text"}
                              required={true}
                            />
                          </Form.Group>
                        </Row>

                        <Form.Group as={Col} className="mb-1">
                          <Form.Label>
                            Email <span className="text-danger">*</span>
                          </Form.Label>
                          <ESInput
                            className={"form-control"}
                            name={"email"}
                            placeholder={"Email"}
                            type={"text"}
                            required={true}
                            regex={/^[\w-\.]+@([\w-]+\.)+[\w-]{2,5}$/}
                          />
                        </Form.Group>

                        <Form.Group as={Col} className="mb-1">
                          <Form.Label>
                            Password <span className="text-danger">*</span>
                          </Form.Label>
                          <ESInput
                            className={"form-control"}
                            name={"password"}
                            placeholder={"Password"}
                            type={"password"}
                            minLength={8}
                            required={true}
                            showEyeIcon={true}
                          />
                        </Form.Group>

                        <Row className="mb-1">
                          <Form.Group as={Col} md={6}>
                            <Form.Label>
                              Country Code{" "}
                              <span className="text-danger">*</span>
                            </Form.Label>
                            <ESInput
                              className={"form-control"}
                              name={"countryCode"}
                              placeholder={"Country Code"}
                              type="tel"
                              required={true}
                            />
                          </Form.Group>

                          <Form.Group as={Col} md={6}>
                            <Form.Label>
                              Contact Number{" "}
                              <span className="text-danger">*</span>
                            </Form.Label>
                            <ESInput
                              className={"form-control"}
                              name={"contactNumber"}
                              placeholder={"Contact Number"}
                              type="tel"
                              required={true}
                              regex={/^[0-9]{10}$/}
                            />
                          </Form.Group>
                        </Row>

                        <Col md={12}>
                          <input
                            type="submit"
                            className="login-btn w-100"
                            value="Sign Up"
                          />
                        </Col>
                      </div>
                    </form>
                  </FormProvider>
                )}
                <Row>
                  <div className="col-md-12 text-center">
                    <button
                      onClick={() => navigate("/login")}
                      className="back-text mt-2"
                    >
                      Already have an account? Login
                    </button>
                  </div>
                </Row>
              </div>
            </Col>
            <Col lg="6" className="px-0 login-bgimg">
              <div className=" text-center">
                <img src={loginbg} alt="Login" title="login" className="" />
                <p>Connect with Surveysides…</p>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
      <Footer />
    </div>
  );
};

export default Signup;
